import React, { useState } from 'react';
import SwedishDateDisplay from './SwedishDateDisplay';
import { History, ChevronDown, ChevronUp } from 'lucide-react';

// Update interface to match the OrderHistory in the codebase
interface OrderHistoryItem {
  id: string;
  order_id: string;
  status: string;
  notes?: string;
  user_email?: string; // Make this optional to match the codebase interface
  created_at: string;
}

interface OrderHistoryTableProps {
  historyItems: OrderHistoryItem[];
  className?: string;
}

/**
 * Component for displaying order history in a table with Swedish date format
 */
const OrderHistoryTable: React.FC<OrderHistoryTableProps> = ({ 
  historyItems,
  className = ''
}) => {
  const [isVisible, setIsVisible] = useState(false);
  
  // Sort history items by date, newest first
  const sortedItems = [...historyItems].sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );

  return (
    <div className={`mb-6 bg-gray-50 p-4 rounded-lg border border-gray-100 ${className}`}>
      <div className="flex justify-between items-center cursor-pointer" onClick={() => setIsVisible(!isVisible)}>
        <div className="flex items-center">
          <History className="w-4 h-4 mr-2" />
          <h3 className="text-lg font-medium text-gray-900">
            Orderhistorik
          </h3>
        </div>
        <button className="text-gray-500 hover:text-gray-700">
          {isVisible ? <ChevronUp className="w-5 h-5" /> : <ChevronDown className="w-5 h-5" />}
        </button>
      </div>
      
      {isVisible && (
        <div className="overflow-hidden mt-3">
          <table className="min-w-full divide-y divide-gray-200 rounded-lg overflow-hidden">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-3 pl-4 pr-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  DATUM
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  STATUS
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  ANTECKNINGAR
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  ANVÄNDARE
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {sortedItems.map((history) => (
                <tr key={history.id}>
                  <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-500">
                    <SwedishDateDisplay date={history.created_at} format="datetime" />
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-700">
                    {history.status}
                  </td>
                  <td className="px-3 py-4 text-sm text-gray-700">
                    {history.notes}
                  </td>
                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    {history.user_email || 'system'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default OrderHistoryTable; 